import React from 'react'
import selectn from 'selectn'
import { getPlayerRoles, getBatsmanComm } from '../../lib/utils/common'
import { PlayerStats } from './index'

/**
 * Display stats for a batsman for lite view (featurephone)
 * @param {Object}        batsman batsman details
 * @param {Number}        bId     batsman iterator (0,1,2 etc)
 * @param {Boolean}       showOutComms  true if out commentary for batsman
 *                                      should show
 * @return {React.Element} batsman stats for featurephone
 */
export const BatsmanLite = ({
  batsman = {},
  bId,
  showOutComms = false
}) => {

  let stats = batsman.stats || []
  let runsScored = selectn('[0].value', stats) || ''

  return (
    <tr className="cricinfo__table__tr" key={bId}>
      <td valign="top" className="cricinfo__table__td">
        <ul className="cricinfo__table__list">
          <li className="cricinfo__table__list__item"
            dangerouslySetInnerHTML={getPlayerRoles(batsman.name, batsman.roles)}>
          </li>

          <PlayerStats stats={stats} excludeStats={[ 'R' ]}/>

          {
          showOutComms ?
          <li className="cricinfo__table__list__item">
            <span className="cricinfo__table__list__item__label"
              dangerouslySetInnerHTML={getBatsmanComm(batsman, bId, 0, true)}>
            </span>
          </li> : null
          }
        </ul>
      </td>
      <td valign="top" className="cricinfo__table__td cricinfo__type__align--right cricinfo__type__weight--bold">{runsScored}</td>
    </tr>
  )
}

export default BatsmanLite



/** WEBPACK FOOTER **
 ** ../app/components/common/BatsmanLite.jsx
 **/